import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { map, of } from 'rxjs';
import { PermissionService } from '../services/permission.service';
import { TenantModulesService } from '../services/tenant-modules.service';
import { TokenStorageService } from '../storage/token-storage.service';

export const guestGuard: CanActivateFn = () => {
  const tokens = inject(TokenStorageService);
  const router = inject(Router);
  const permissions = inject(PermissionService);
  const tenantModules = inject(TenantModulesService);

  if (!tokens.hasValidTokens()) {
    return true;
  }

  const modulesReady$ =
    tenantModules.enabled() !== null ? of(void 0) : tenantModules.refreshAsync().pipe(map(() => void 0));

  return modulesReady$.pipe(
    map(() => {
      void router.navigateByUrl(permissions.firstAccessibleAdminPath() ?? '/unauthorized');
      return false;
    }),
  );
};
